import type { ILocation } from "@/data/model/Location";
import type { ICurrentAppService } from "@/data/services/CurrentAppService";
import type { ICurrentLocationService } from "@/data/services/CurrentLocationService";



import { OperatorClient } from "@/operator/OperatorClient";


export class OperatorCurrentLocationService implements ICurrentLocationService {
    public getLocationId(): string | undefined {
        return this.getLocation()?.id;
    }

    public getLocation(): ILocation | undefined {
        return OperatorClient.context?.settings?.location;
    }
}

export class OperatorCurrentService implements ICurrentAppService {
    getNativeAppMode(): boolean {
        return OperatorClient.context?.getNativeAppMode() ?? false;
    }

    getIsWalleeSdkAvailable(): boolean | undefined {
        return OperatorClient.context?.getIsWalleeSdkAvailable();
    }
}